<template> 
    <div class="scroll-container">
<div class="icon-scroll"></div>
</div>
</template>
<script>
    export default {
        name: 'icon-scroll'
    }
</script>
<style>
    
    .scroll-container {
  height: 70px;
}
  .icon-scroll,
  .icon-scroll:before {
    position: absolute;
    left: 50%;
  }

  .icon-scroll {
    width: 40px;
    height: 70px;
    margin-left: -20px;
    /*top: 50%;*/
    /*margin-top: -35px;*/
    box-shadow: inset 0 0 0 1px #76fbfd;
    border-radius: 25px;
  }

  .icon-scroll:before {
    content: '';
    width: 8px;
    height: 8px;
    background: #76fbfd;
    margin-left: -4px;
    top: 8px;
    border-radius: 4px;
    -webkit-animation-duration: 1.5s;
    animation-duration: 1.5s;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    -webkit-animation-name: scroll;
    animation-name: scroll;
  }

  @-webkit-keyframes scroll {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      -webkit-transform: translateY(46px);
      transform: translateY(46px);
    }
  }

  @keyframes scroll {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      -webkit-transform: translateY(46px);
      transform: translateY(46px);
    }
  }
</style>